const services = {
  brands: 'Brands',
  addBrand: 'Add Brand',
  editBrand: 'Edit Brand',
};
export default services;
